import React from "react";
import { Modal, List } from "antd";

const ModalStockVLX = ({ open, items, onClose, onSelect }) => {
  return (
    <Modal
      open={open}
      title="Seleccione lote / vencimiento"
      footer={null}
      onCancel={onClose}
    >
      <List
        dataSource={items}
        renderItem={(item) => {
          const valcar =
            item?.valcar ||
            item?.nomfis ||
            item?.lote_vto ||
            item?.loteVto ||
            "";

          const sku =
            item.articulologico_sku ||
            item.sku ||
            item.codigo ||
            item.articulologico_codigo ||
            "";

          const nombre =
            item.articulologico_nombre || item.nombre || item.descripcion || "";

          return (
            <List.Item
              onClick={() => onSelect(item)}
              style={{
                cursor: "pointer",
                padding: "12px 8px",
              }}
            >
              <List.Item.Meta
                title={valcar || "Sin lote/vto"}
                description={`${sku}${nombre ? ` - ${nombre}` : ""}`}
              />
            </List.Item>
          );
        }}
      />
    </Modal>
  );
};

export default ModalStockVLX;
